import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationProvinceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Province/ProvinceBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationProvince"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationProvince"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationProvinceActivity)
